export default function getChildCount(parentElem) {
	if (!parentElem) {
		console.warn("getChildCount: parentElem is null");
		return null;
	}

	return parentElem.children.length;
}
